import { ShortcutKey, SHORTCUTS } from '@/consts/shortcuts';
import { getOS } from './general';

const CAP_CTRL = 'Ctrl';
const CAP_ALT = 'Alt';
const CAP_SHIFT = 'Shift';
const CAP_ENTER = 'Enter';

type ShortcutEntry = (typeof SHORTCUTS)[ShortcutKey];

const replacePerPlatformForCombination = (res: string) => {
  if (getOS() === 'Mac') {
    return res.replace(/ctrl\|meta/g, 'meta');
  }
  return res.replace(/ctrl\|meta/g, 'ctrl');
};

const replacePerPlatformForDisplay = (res: string) => {
  if (getOS() === 'Mac') {
    return res
      .replace(/ctrl\|meta\+/g, '⌘')
      .replace(/(option|alt)/g, '⌥')
      .replace(/ctrl/g, '⌃')
      .replace(/shift/g, '⇧')
      .replace(/enter/g, '⏎');
  }
  return res
    .replace(/ctrl\|meta/g, CAP_CTRL)
    .replace(/option/g, CAP_ALT)
    .replace(/ctrl/g, CAP_CTRL)
    .replace(/shift/g, CAP_SHIFT)
    .replace(/alt/g, CAP_ALT)
    .replace(/enter/g, CAP_ENTER);
};

export const getDescription = (key: ShortcutKey): string => {
  return replacePerPlatformForDisplay(SHORTCUTS[key].DESCRIPTION);
};

const displayToken = (token: string, isMac: boolean): string => {
  if (token === 'ctrl|meta') return isMac ? '⌘' : CAP_CTRL;
  if (token === 'ctrl') return isMac ? '⌃' : CAP_CTRL;
  if (token === 'shift') return isMac ? '⇧' : CAP_SHIFT;
  if (token === 'alt' || token === 'option') return isMac ? '⌥' : CAP_ALT;
  if (token === 'enter') return isMac ? '⏎' : CAP_ENTER;
  return token.toUpperCase();
};

export const getShortcutParts = (key: ShortcutKey): string[] => {
  const isMac = getOS() === 'Mac';
  const parts = SHORTCUTS[key].DESCRIPTION.split('+').map((t) => displayToken(t, isMac));

  if (!isMac && parts.length > 1) {
    return parts.flatMap((p, i) => (i > 0 ? ['+', p] : [p]));
  }
  return parts;
};

export const getShortcut = (key: ShortcutKey): string => {
  const shortcut: ShortcutEntry = SHORTCUTS[key];
  const res = 'KEY_COMBINATION' in shortcut ? shortcut.KEY_COMBINATION(shortcut.PATTERN) : shortcut.DESCRIPTION;

  return replacePerPlatformForCombination(res);
};
